import { Injectable } from '@angular/core';
import {env} from "@environments/environment";
import {HttpClient} from "@angular/common/http";
import {
  MedicalDevicesForPersonalOfferInterface,
  PersonalOfferCreateRequestInterface, PersonalOfferInterface,
  PersonalOffersResponseInterface,
  RedistributionRequestCreateInterface, RedistributionRequestInterface, RedistributionRequestsResponseInterface
} from "@app/redistribution/redistribution.interface";
import {Observable, of} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class RedistributionApiService {

  constructor(
      private http: HttpClient
  ) { }
  
  public getRedistributionRequests(
      data: { },
      params: {page: number, size: number, sort?: string[]}) {
    
    // @ts-ignore
    const queryParams = new URLSearchParams(params).toString();
    const url = env.apiUrl + '/accounting/v1/redistribution-request/filter?' + queryParams;
    return this.http.post<RedistributionRequestsResponseInterface>(url , data, {})
  }
  
  public getRedistributionRequest(id: number): Observable<RedistributionRequestInterface> {
    
    const url = env.apiUrl + '/accounting/v1/redistribution-request/' + id;
    return this.http.get<RedistributionRequestInterface>(url);
  }
  
  public getRedistributionRequestPersonalOfferings(id: number, pagination: {}): Observable<PersonalOffersResponseInterface> {
    
    const queryParams = new URLSearchParams(pagination).toString();
    const url = env.apiUrl + `/accounting/v1/redistribution-request/${id}/personal-offer?${queryParams}`;
    return this.http.get<PersonalOffersResponseInterface>(url);
  }
  
  public getUniqMedicalDevicesRedistributionRequest(s: string) {
    
    const queryParams = new URLSearchParams({filter: s}).toString();
    const url = env.apiUrl + '/accounting/v1/medicines-medical-devices/filter/redistribution?' + queryParams;
    return this.http.get<Array< {tradeName: string, mnn: string, dosage: string, direction: string}>>(url);
  }
  
  public createRedistributionRequest(body: RedistributionRequestCreateInterface) {
    
    const url = env.apiUrl + '/accounting/v1/redistribution-request';
    return this.http.post<RedistributionRequestInterface>(url, body);
  }
  
  public putPersonalProposal(data: PersonalOfferCreateRequestInterface) {
    
    const url = env.apiUrl + '/accounting/v1/personal-offer';
    return this.http.post<PersonalOfferInterface>(url, data);
  }
  
  public rejectPersonalProposal(id: number) {
    
    const url = env.apiUrl + `/accounting/v1/personal-offer/${id}/reject`;
    return this.http.post(url, {});
  }
  
  public confirmPersonalProposal(id: number) {
    
    const url = env.apiUrl + `/accounting/v1/personal-offer/${id}/confirm`;
    return this.http.post(url, {});
  }
  
  public cancelPersonalProposal(id: number, s: string = '') {
    
    const url = env.apiUrl + `/accounting/v1/personal-offer/${id}/cancel`;
    return this.http.post(url, { reasonForCancellation: s });
  }
  
  public cancelRedistributionRequest(id: number, s: string = '') {
    
    const url = env.apiUrl + `accounting/v1/redistribution-request/${id}/cancel`;
    return this.http.post(url, { reasonForCancellation: s });
  }
  
  public getMedicalDevicesForPersonalOffer(filter: {
    dosage: string | null;
    mnn: string;
    direction: string;
    organizationId: number;
    tradeName: string
  }): Observable<Array<MedicalDevicesForPersonalOfferInterface>> {
    
    // @ts-ignore
    const queryParams = new URLSearchParams(filter).toString();
    const url = env.apiUrl + `/accounting/v1/medicines-medical-devices/filter/redistribution/personal-offer?${queryParams}`;
    return this.http.get<Array<MedicalDevicesForPersonalOfferInterface>>(url)
  }

}
